module.exports = __webpack_public_path__ + "media/twitter.b09f0184.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/app-website/assets/twitter.svg
// module id = ./src/templates/app-website/assets/twitter.svg
// module chunks = 0